module.exports = __webpack_public_path__ + "media/assets/svgs/funeral-live-logo-0e00be217a836ac0aba896915636cec3.png";